import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAperture, FiGrid, FiCamera, FiPlayCircle, FiSettings, FiLogOut, FiHelpCircle } = FiIcons;

const Sidebar = ({ activeTab, setActiveTab }) => {
  const navItems = [
    { id: 'dashboard', icon: FiGrid, label: 'COMMAND' },
    { id: 'project', icon: FiCamera, label: 'ACTIVE SHOOT' },
    { id: 'demo', icon: FiPlayCircle, label: 'DEMO / FLOW' },
    { id: 'settings', icon: FiSettings, label: 'SYSTEM' },
  ];

  return (
    <div className="hidden md:flex flex-col w-64 bg-[#0a0a0a] border-r border-[#222] h-screen fixed left-0 top-0 z-40">
      <div className="p-6 flex items-center gap-3 border-b border-[#222]">
        <div className="text-pink-500">
          <SafeIcon icon={FiAperture} className="w-8 h-8 animate-[spin_10s_linear_infinite]" />
        </div>
        <div>
          <h1 className="font-mono text-white text-xl tracking-widest font-bold">PHOTOPILOT</h1>
          <p className="font-mono text-[10px] text-pink-500 tracking-[0.2em] uppercase">Enterprise v2.4</p>
        </div>
      </div>

      <div className="flex-1 py-8 px-4 flex flex-col gap-2">
        <p className="font-mono text-xs text-[#555] mb-2 px-2 uppercase tracking-widest">Main Menu</p>
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`flex items-center gap-4 px-4 py-3 rounded-none font-mono text-sm tracking-wider transition-all duration-300 relative group
              ${activeTab === item.id ? 'text-white bg-white/5' : 'text-[#777] hover:text-[#ccc] hover:bg-white/5'}`}
          >
            {activeTab === item.id && (
              <motion.div
                layoutId="activeNav"
                className="absolute left-0 top-0 w-1 h-full bg-pink-500"
                initial={false}
              />
            )}
            <SafeIcon icon={item.icon} className={`w-5 h-5 ${activeTab === item.id ? 'text-pink-500' : 'group-hover:text-pink-500/50'}`} />
            {item.label}
          </button>
        ))}
      </div>

      <div className="p-4 flex flex-col gap-4 border-t border-[#222] bg-[#0d0d0d]">
        <button className="flex items-center gap-3 px-3 py-2 font-mono text-[10px] text-[#555] hover:text-white transition-colors">
          <SafeIcon icon={FiHelpCircle} className="w-4 h-4" />
          DOCUMENTATION
        </button>
        <div className="flex items-center gap-3 px-2 py-2">
          <div className="w-8 h-8 rounded-full bg-zinc-800 border border-zinc-600 flex items-center justify-center overflow-hidden">
             <img src="https://images.unsplash.com/photo-1599566150163-29194dcaad36?q=80&w=100&auto=format&fit=crop" alt="User" />
          </div>
          <div className="flex-1">
            <p className="font-mono text-xs text-white">SYS_ADMIN</p>
            <p className="font-mono text-[10px] text-[#666]">Lvl 4 Access</p>
          </div>
          <button className="text-[#555] hover:text-pink-500 transition-colors">
            <SafeIcon icon={FiLogOut} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;